import { useContext } from "react";
import { OrganogramContext } from "../contexts/OrganogramContext";

export const useOrganogramContext = () => {
    return useContext(OrganogramContext);
};